import axiosInstance from './axiosInstance';

export const getMyReferrals = () => axiosInstance.get('/users/my-referrals');
export const getLevelUsers = () => axiosInstance.get('/users/level-users');
